var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconHoriAlignCenter24 = function SvgIconHoriAlignCenter24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.85 5.501v13h-1.7v-13h1.7ZM8.446 12.85H3.47v-1.7h4.975v1.7Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.142 11.02c.562.532.562 1.429 0 1.96l-2.734 2.603-1.035-1.086L7.995 12 5.373 9.503l1.035-1.086 2.734 2.604ZM15.56 11.15h4.976v1.7H15.56v-1.7Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m16.006 12 2.621-2.497-1.034-1.086-2.734 2.604a1.348 1.348 0 0 0 0 1.959l2.734 2.603 1.034-1.086L16.006 12Z",
    fill: "current"
  })));
};
export default SvgIconHoriAlignCenter24;